<template>

  <div class="cf">
    <div class="cf-success">

      <span class="cf-success__icon cf-success__icon--muted">–</span>

      <div class="cf-stack" style="gap:10px;align-items:center">
        <span class="cf-eyebrow cf-eyebrow--muted">Decyzja</span>
        <h1 class="cf-h1">Niestety, w tym momencie nie możemy udzielić Ci pożyczki</h1>
        <p class="cf-lead" style="margin:0 auto">Możesz sprawdzić ofertę u naszego partnera — wystarczy jedno kliknięcie.</p>
      </div>

      <div class="cf-row" style="justify-content:center">
        <a key="btn-next" class="cf-btn cf-btn--primary" @click="goredirect">Sprawdź ofertę partnera</a>
      </div>

    </div>
  </div>

</template>

<script>

    import { bus } from './main';

        

    export default {
     
       name: 'RedirectView',
 

       data(){

            return {

            }
       },


       methods: {



        goredirect(){

           // this.$router.push({path: '/'});


           // window.location = "https://tarata.pl/?partnerName=leadgrid&partnerUid=rjcreditu";
            window.location = "https://track.leadperial.com/click?pid=46&offer_id=26&sub1=decline";
        }
       },



       mounted(){



            // scroll to top with .5s delay
            this.pageTop();

       }



        
    }
</script>

<style scoped>

.cf-page {
  padding: 44px 64px 56px;
  max-width: 960px;
}

.cf-easycheck__widget {
  padding: 24px;
  display: flex;
  justify-content: center;
}

@media (max-width: 900px) {

  .cf-page {
    padding: 24px 18px 40px;
  }
}

</style>



// WEBPACK FOOTER //
// src/RedirectView.vue